import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import users from './modules/users'
import laboratories from './modules/laboratories'
import distributors from './modules/distributors'
import products from './modules/products'
import invoices from './modules/invoices'
import transit from './modules/transit'
import dashboard from './modules/dashboard'
import feeds from './modules/feeds'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    session,
    users,
    laboratories,
    distributors,
    products,
    invoices,
    transit,
    dashboard,
    feeds,
  },
})

export default store
